/*require('./../../style/organiz-structure.less');*/
var Component = require('./../Component'),
    $ = require('jQuery'),
    template = require('./../../template/organiz-structure.html'),
    dispatcher = require('./../../global/dispatcher'),
    ContactStatus = require('./../../constant/ContactStatus'),
    ActionType = require('./../../constant/ActionType'),
    config = require('./../../global/config');
var utils = require('./../../global/utils');
var isGroupUser = utils.isGroupUser;
var isAddGroup = false;
var isDeleteGroup = false;
var isCreateGroup = false;
var personDom = {}    // key:user_id@user_source  val:html
var selectedPersonDom = {};
var selectedPersonDomLen = 0;
var selectedPerson={};
var maxInviteNum = 50;
var maxDeleteNum = 40;
var OrganizStructure = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    var ele = options && options.ele ? options.ele : null;
    this.contact = options && options.contact ? options.contact : {};
    isAddGroup = options && options.isAddGroup ? options.isAddGroup : false;
    isDeleteGroup = options && options.isDeleteGroup ? options.isDeleteGroup : false;
    isCreateGroup = options && options.isCreateGroup ? options.isCreateGroup : false;
    this.init(ele);

    // click each item
    (function (self) {
        $('#im-search-inp').on('keydown',function(e){
            if(e.keyCode === 13){
                var ele = options && options.ele ? options.ele : null;
                self.search(ele);
            }
        })
        var ele = options && options.ele ? options.ele : self.getElement();
        ele.on('click', '.im-organization-item', function (e) {
            var $this = $(this);
            if ($this.attr("data-type") == "group") {
                self.organizationOpen($this);
            } else {
                self.checkItem($this);
            }
        });
        if (isAddGroup || isDeleteGroup) {
            if (isGroupUser(self.contact)) {
                if (isAddGroup) {
                    self.showTp($('.im-organization-handle-btn.join'));
                    self.hideTp($('.im-organization-handle-btn.create'));
                    self.hideTp($('.im-organization-handle-btn.delete'));
                } else if (isDeleteGroup) {
                    self.hideTp($('.im-organization-handle-btn.join'));
                    self.showTp($('.im-organization-handle-btn.delete'));
                    self.hideTp($('.im-organization-handle-btn.create'));
                }
            } else {
                self.hideTp($('.im-organization-handle-btn.join'));
                self.hideTp($('.im-organization-handle-btn.delete'));
                self.showTp($('.im-organization-handle-btn.create'));
                // 单聊把当前联系人加入到已选择的列表
                var personKey = self.contact.user_id + '@' + self.contact.user_source;
                var person = '<li class="im-organization-person" data-id="';
                person += self.contact.user_id;
                person += '" data-source ="';
                person += self.contact.user_source;
                person += '"><div class="im-organization-item" data-type="person" data-level="0';
                person += '"><div class="im-organization-item-wrap">';
                person += '<img src="' + self.contact.avatar + '" alt="" class="im-organization-avatar"><span class="im-organization">';
                person += self.contact.user_name + '</span></div></div></li>';
                person = person.split('</li>')[0] + '<span class="im-organization-selected-del" data-type="del"></span></li>';
                selectedPersonDom[personKey] = person;
                selectedPerson[personKey] = self.contact;
                selectedPersonDomLen++;
                $('.im-organization-selected-lists.add-group').append(person);
            }
            ele.on('click', '.im-organization-person', function (e) {
                var $this = $(this);
                var $parent = $this.parent('.im-organization-person');
                var personKey = $parent.context.getAttribute('data-id') + '@' + $parent.context.getAttribute('data-source');
                if (e.target && e.target.checked) {
                    var not_included = self._options.unavailableGroup || {};
                    if (not_included[personKey]) return;
                    var person = personDom[personKey];
                    person = person.split('</li>')[0] + '<span class="im-organization-selected-del" data-type="del"></span></li>';
                    selectedPersonDom[personKey] = person;
                    selectedPerson[personKey] = self.contact;
                    selectedPersonDomLen++;
                    $('.im-organization-selected-lists.add-group').append(person);
                } else if (e.target && !e.target.checked) {
                    var not_included = self._options.unavailableGroup || {};
                    if (not_included[personKey]) return;
                    var persons = '';
                    var count = 0;
                    delete (selectedPersonDom[personKey]);
                    delete (selectedPerson[personKey]);
                    $.each(selectedPersonDom, function (key, item) {
                        count++;
                        persons += item;
                    })
                    selectedPersonDomLen = count;
                    $('.im-organization-selected-lists.add-group').html(persons);
                }
                $('.im-organization-selected-num').text('已选择的联系人(' + selectedPersonDomLen + ')');
                e.stopPropagation();
            })
            $('.im-contactwindow-organization.add-group').on('click', '.im-organization-selected-del', function (e) {
                var $this = $(this);
                if (e.target && e.target.getAttribute('data-type') === 'del') {
                    var $parent = $this.parent('.im-organization-person');
                    var personKey = $parent[0].getAttribute('data-id') + '@' + $parent[0].getAttribute('data-source');
                    delete (selectedPersonDom[personKey]);
                    delete (selectedPerson[personKey]);
                    selectedPersonDomLen--;
                    $parent.remove();
                    $('.im-organization-selected-num').text('已选择的联系人(' + selectedPersonDomLen + ')');
                    var lists = $('.im-origanization-member');
                    $.each(lists, function (index, value) {
                        if ($(this)[0].getAttribute('data-key') === personKey) {
                            $(this).attr('checked', false);
                        }
                    })
                }
            })

            $('.im-contactwindow-organization.add-group').on('click', '.im-organization-handle', function (e) {
                var handleType = e.target && e.target.getAttribute('data-type');
                var not_included = self._options.unavailableGroup || {};
                var selectPerson = [];
                $.each(selectedPersonDom, function (key, item) {
                    var arr = key.split('@');
                    if (not_included[key]) return;
                    selectPerson.push({
                        user_id: arr[0],
                        user_source: arr[1]
                    })
                })
                if (selectPerson.length > 0) {
                    var maxGroupCount = self.contact && self.contact.group_info && self.contact.group_info.max_count;
                    switch (handleType) {
                        case 'create':
                            // 当前联系人加入群聊
                            const { user_id, user_source } = self.contact
                            selectPerson.push({
                                user_id, user_source
                            })
                            if (selectPerson.length < 2 || selectPerson.length > maxGroupCount) {
                                var text = selectPerson.length < 2 ? '群聊人数至少超过2人!' : '群成员不能超过' + maxGroupCount + '人!';
                                dispatcher.dispatch({
                                    type: ActionType.TOAST_SHOW,
                                    data: {
                                        content: text,
                                        interval: 3000
                                    }
                                });
                                return;
                            }
                            dispatcher.dispatch({
                                type: ActionType.CREATE_GROUP_CHECK,
                                data: selectPerson
                            });
                            break;
                        case 'join':
                            if (!self.contact || !self.contact.user_id || !self.contact.user_source) {
                                return;
                            }
                            if (selectPerson.length > maxInviteNum) {
                                dispatcher.dispatch({
                                    type: ActionType.TOAST_SHOW,
                                    data: {
                                        content: '每次邀请人数不能超过' + maxInviteNum + '人!',
                                        interval: 3000
                                    }
                                });
                                return;
                            }
                            var groupInfo = self.contact && self.contact.group_info;
                            var currentCnt = groupInfo && groupInfo.current_count;
                            var inviteCnt = groupInfo && groupInfo.invite_cnt;
                            var authority = groupInfo && groupInfo.authority;
                            var isAuthType = groupInfo && groupInfo.auth_type == 1;
                            // 判断当前群邀请是否需要认证
                            if (isAuthType && authority != 1) {
                                var text = '群主已启用"群聊邀请确认",群成员需群主确认才能邀请朋友进群';
                                dispatcher.dispatch({
                                    type: ActionType.TOAST_SHOW,
                                    data: {
                                        content: text,
                                        interval: 2000
                                    }
                                });
                            }
                            if (inviteCnt !== 0 && currentCnt > inviteCnt && !isAuthType) {
                                dispatcher.dispatch({
                                    type: ActionType.TOAST_SHOW,
                                    data: {
                                        content: '当前群聊人数较多，为减少打扰，对方同意邀请后才会进入群聊!',
                                        interval: 3000
                                    }
                                });
                            }
                            dispatcher.dispatch({
                                type: ActionType.JOIN_GROUP_CHECK,
                                data: {
                                    contact: self.contact,
                                    target_ggid: self.contact.user_id,
                                    target_gsource: self.contact.user_source,
                                    target_users: selectPerson,
                                    callback: self._options.callback
                                }
                            });
                            break;
                        case 'delete':
                            if (!self.contact || !self.contact.user_id || !self.contact.user_source) {
                                return;
                            }
                            var groupInfo = self.contact && self.contact.group_info;
                            var isAuthor = groupInfo && groupInfo.authority == 1;
                            if (!isAuthor) return;
                            if (selectPerson.length > maxDeleteNum) {
                                dispatcher.dispatch({
                                    type: ActionType.TOAST_SHOW,
                                    data: {
                                        content: '每次删除人数不能超过' + maxDeleteNum + '人!',
                                        interval: 3000
                                    }
                                });
                                return;
                            }
                            var members = [];
                            selectPerson.forEach(function (person) {
                                members.push({
                                    user_id: person.user_id,
                                    user_source: person.user_source,
                                    authority: 4
                                });
                            });
                            dispatcher.dispatch({
                                type: ActionType.DELETE_MEMBER,
                                data: {
                                    members: members
                                }
                            });
                            break;
                        default:
                            break;
                    }
                }
                $('.im-organization-selected-lists.add-group').html('');
                $('.im-organization-selected-num').text('已选择的联系人(0)');
                $('.im-origanization-member').attr('checked', false);
                selectedPersonDom = {};
                selectedPerson = {};
                selectedPersonDomLen = 0;
                self.contact = null;
                $('.im-contactwindow-organization.add-group').remove();
                self.triggerEvent("structureUnmount", handleType);
            })
        }
    })(this);
};

OrganizStructure.prototype = Object.create(Component.prototype);

// 初始化组织结构
OrganizStructure.prototype.init = function ($ele) {
    var ulList = $ele ? $ele : this.getElement().find(".im-organization-list"),
        ulInput = $(".im-contactwindow-organization.add-group .im-search-input input#im-search-inp"),
        self = this;
    if (isDeleteGroup) {
        if (self._options && self._options.groupMembers && self._options.groupMembers.length) {
            self.insertOrganization(self._options.groupMembers, ulList, 0);
        }
    } else {
        config.organization.getDetailByGroup("", function (data) {
            self.insertOrganization(data, ulList, 0);
        });
    }
    // $('#im-search-inp').on('keydown',function(e){
    //     if(e.keyCode === 13){
    //         console.log('回车搜索')
    //         self.search();
    //     }
    // })
    // if(isAddGroup && isGroupUser(self.contact)){
      $('.im-contactwindow-organization.add-group').on('click', '.im-search-submit.js-search-submit', (function(){
        var timer = null;
        var isloading = false;
        var callback = function () {
            var val = ulInput.val();
            isloading = true;
            if(!utils.isEmpty(val) && val.length){
              ulList.html('');
              config.organization.search(val, function (data) {
                if(!utils.isEmpty(data) && data.length) {
                  self.insertOrganization(data, ulList, 0);
                } else {
                  ulList.html('<div class="im-empty-list"><span class="im-empty-label">无搜索结果</span></div>');
                }
                isloading = false;
              });
            }else{
              ulList.html('');
              config.organization.getDetailByGroup("", function (data) {
                  self.insertOrganization(data, ulList, 0);
                  isloading = false;
              });
            }
        };
        return function(){
          if(isloading)return;
          if(timer){
            clearTimeout(timer);
            timer = null;
          }
          timer = setTimeout(function(){
            callback();
          }, 100);
        };
      })());
    // }
};
OrganizStructure.prototype.search = function($ele){
    var ulList = $ele ? $ele : this.getElement().find(".im-organization-list"),
    ulInput = $(".im-contactwindow-organization.add-group .im-search-input input#im-search-inp"),
    self = this;
    var val = ulInput.val();
    if(!utils.isEmpty(val) && val.length){
      ulList.html('');
      config.organization.search(val, function (data) {
        if(!utils.isEmpty(data) && data.length) {
          self.insertOrganization(data, ulList, 0);
        } else {
          ulList.html('<div class="im-empty-list"><span class="im-empty-label">无搜索结果</span></div>');
        }
      });
    }else{
      ulList.html('');
      config.organization.getDetailByGroup("", function (data) {
          self.insertOrganization(data, ulList, 0);
      });
    }
};
/*
 *点击展开组织部门
 * $ele:被点击的DOM
 * */
OrganizStructure.prototype.organizationOpen = function ($ele) {
    var group_id = $ele.parent().attr("data-groupid"),
        ulList = $ele.siblings(".im-organization-list"),
        self = this,
        level = parseInt($ele.attr("data-level")) + 1,
        spreadIcon = $ele.find(".im-organization-item-close");
    if (spreadIcon.hasClass("im-organization-item-open")) {
        spreadIcon.removeClass("im-organization-item-open");
        if (ulList.children().length) {
            ulList.slideDown("fast", function () {
                $(this).stop(true, true);
                self.triggerEvent("contentHeightChange");
            });
        } else {
            config.organization.getDetailByGroup(group_id, function (data) {
                if(data && data.length){
                    self.insertOrganization(data, ulList, level);
                    ulList.slideDown("fast", function () {
                        $(this).stop(true, true);
                        self.triggerEvent("contentHeightChange");
                    });
                }else{
                    self.triggerEvent("contentHeightChange");
                }
            });
        }
    } else {
        spreadIcon.addClass("im-organization-item-open");
        ulList.slideUp("fast", function () {
            $(this).stop(true, true);
            self.triggerEvent("contentHeightChange");
        });
    }
};

/*
 * 向DOM中插入数据
 * data:返回的数据
 * $ele:待插入的im-organization-list
 * level:树结构的级数
 * */
OrganizStructure.prototype.insertOrganization = function (data, $ele, level) {
    var organization, i, person;
    var meKey = config['me']().user_id + '@' + config['me']().user_source;
    var not_included = this._options.unavailableGroup || {};
    if (!not_included[meKey]) {
        not_included[meKey] = config['me']();
        $.extend(true, not_included, selectedPerson);
    }
    var personKey
    for (i in data) {
        if (!data.hasOwnProperty(i)) {
            continue;
        }
        if (data[i].source) {
            person = '<li class="im-organization-person" data-id="';
            person += data[i].id;
            person += '" data-source ="';
            person += data[i].source;
            person += '"><div class="im-organization-item" data-type="person" data-level="';
            person += level;
            person += '"><div class="im-organization-item-wrap">';
            person += '<img src="' + data[i].avatar + '" alt="" class="im-organization-avatar"><span class="im-organization">';
            person += data[i].name;
            if (isAddGroup) {
                personKey = data[i].id + '@' + data[i].source;
                personDom[personKey] = person + '</span></div></div></li>';
                person += '</span></div></div><input data-type="checkbox" data-key=' + personKey + ' class="im-origanization-member" type="checkbox" value=""';
                if(personKey !== meKey && isCreateGroup){
                  person += (not_included[personKey] ? ' checked/></li>' : '/></li>');
                }else{
                  person += (not_included[personKey] ? ' disabled checked/></li>' : '/></li>');
                }
            } else if (isDeleteGroup) {
                if (this._options.master && this._options.master.user_id == data[i].id && this._options.master.user_source == data[i].source) continue;
                personKey = data[i].id + '@' + data[i].source;
                personDom[personKey] = person + '</span></div></div></li>';
                person += '</span></div></div><input data-type="checkbox" data-key=' + personKey + ' class="im-origanization-member" type="checkbox" value=""/></li>';
            } else {
                person += '</span></div></div></li>';
            }
            $ele.append(person);
        } else {
            organization = '<li class="im-organization-group" data-groupid=';
            organization += data[i].id;
            organization += '><div class="im-organization-item" data-type="group" data-level="';
            organization += level;
            organization += '"><div class="im-organization-item-wrap"><i class="im-organization-item-close im-organization-item-open">&nbsp;</i><i class="im-organization-item-logo">&nbsp;</i><span class="im-organization">';
            organization += data[i].name;
            organization += '</span></div></div><ul class="im-organization-list im-hide"></ul></li>';
            $ele.append(organization);
        }
    }
    $ele.find(".im-organization-item").each(function () {
        $(this).css({
            "paddingLeft": 19 * level + "px"
        });
    });
};

/*
 * 点击item
 * $ele:被点击的DOM
 * */
OrganizStructure.prototype.checkItem = function ($ele) {
    var $userItem = $ele.parent(".im-organization-person"),
        user_id = $userItem.attr("data-id"),
        checkedItem = this.getElement().find(".im-organization-checked");
    if (user_id && !isAddGroup) {
        if (checkedItem) {
            checkedItem.removeClass("im-organization-checked");
        }
        $ele.addClass("im-organization-checked");
        dispatcher.dispatch({
            type: ActionType.PERSON_CHECK,
            data: {
                user_id: user_id,
                user_source: $userItem.attr("data-source")
            }
        });
    }
};
OrganizStructure.prototype.showTp = function (ele) {
    ele && ele.show();
};
OrganizStructure.prototype.hideTp = function (ele) {
    ele && ele.hide();
};
module.exports = OrganizStructure;
